import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=bc5f0df6"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=bc5f0df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports